import { Microphone } from '@phosphor-icons/react';

export default Microphone;
